import { render, staticRenderFns } from "./AddSpotIcon.vue?vue&type=template&id=38c948a6&scoped=true&"
import script from "./AddSpotIcon.vue?vue&type=script&lang=js&"
export * from "./AddSpotIcon.vue?vue&type=script&lang=js&"
import style0 from "./AddSpotIcon.vue?vue&type=style&index=0&id=38c948a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c948a6",
  null
  
)

export default component.exports